// npm install
// npm run dev
// nothing really gets done in this file everything kicks off in App.vue
import Vue from 'vue'
import App from './App'

/* eslint-disable no-new */
new Vue({
  el: 'body',
  components: { App }
})


/** WEBPACK FOOTER **
 ** ./src/main.js
 **/